"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _FactPercentageIcon = _interopRequireDefault(require("../images/GeneralVector/FactPercentageIcon"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ProgressRing = props => {
  const [offset, setOffset] = (0, _react.useState)(0);
  const circleRef = (0, _react.useRef)(null);
  const {
    circleOneStroke,
    circleTwoStroke,
    customIcon = null,
    iconColor = {},
    progress,
    showIcon = true,
    showIconComplete = false,
    showIconCompleteColor = 'greeen',
    showIconCompleteSize = 'normal',
    size,
    strokeWidth
  } = props;
  const center = size / 2;
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  (0, _react.useEffect)(() => {
    const progressOffset = (100 - progress) / 100 * circumference;
    setOffset(progressOffset);
    if ((0, _get.default)(circleRef, 'current', null)) {
      const circleStyle = circleRef.current;
      circleStyle.style = 'transition: stroke-dashoffset 850ms ease-in-out';
    }
  }, [setOffset, progress, circumference, offset]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pos-r"
  }, showIcon && !showIconComplete && (/*#__PURE__*/_react.default.createElement("div", {
    className: "factIcon pos-a xy-c dis-f jc-c a-c"
  }, /*#__PURE__*/_react.default.createElement(_FactPercentageIcon.default, null))), showIconComplete && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "factIcon pos-a xy-c",
    color: showIconCompleteColor,
    saturationTxt: 600,
    icon: "check",
    iconSize: showIconCompleteSize
  })), customIcon && !showIcon && !showIconComplete && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "factIcon pos-a xy-c",
    color: iconColor.color,
    saturationTxt: iconColor.sat,
    icon: customIcon
  })), /*#__PURE__*/_react.default.createElement("svg", {
    className: "progressRing",
    width: size,
    height: size
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "svg-circle-bg",
    stroke: circleOneStroke,
    cx: center,
    cy: center,
    r: radius,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_react.default.createElement("circle", {
    className: "svg-circle",
    ref: circleRef,
    stroke: circleTwoStroke,
    cx: center,
    cy: center,
    r: radius,
    strokeWidth: strokeWidth,
    strokeDasharray: circumference,
    strokeDashoffset: offset
  })));
};
var _default = exports.default = ProgressRing;